import { startRoundTrip } from '@sentinel/web-core';
import { ErrorState } from '@sentinel/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthFrame } from './AuthFrame';

/** The console signs in through `accounts.` (ADR 0013): off there, back with a code. */
export function StartPage() {
  const { t } = useTranslation();
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    void startRoundTrip().then((started) => setUnavailable(!started));
  }, []);

  return (
    <AuthFrame>
      {unavailable ? (
        <ErrorState title={t('console.auth.hostTitle')} description={t('console.auth.hostText')} />
      ) : (
        <div className="indet" role="progressbar" aria-label={t('console.auth.leaving')} />
      )}
    </AuthFrame>
  );
}
